import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Header } from "@/components/Header";
import { useT, useDocumentTitleKey } from "@/i18n/locale-context";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({ meta: [{ title: "Mot de passe oublié — Glow Up Coach" }] }),
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  useDocumentTitleKey("forgot.head.title");
  const t = useT();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) throw error;
      setSent(true);
      toast.success(t("forgot.toast.sent"));
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <div className="max-w-md mx-auto px-6 py-20">
        <h1
          className="font-display font-bold text-3xl mb-2 tracking-tight"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {t("forgot.title")}
        </h1>
        <p className="text-muted-foreground text-sm mb-8">{t("forgot.subtitle")}</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <input
            type="email"
            required
            placeholder={t("forgot.input.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-foreground/15 bg-background text-sm focus:outline-none focus:border-accent"
          />
          <button
            type="submit"
            disabled={loading || sent}
            className="w-full bg-foreground text-background py-3 rounded-xl text-sm font-semibold hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "…" : sent ? "✓" : t("forgot.btn.send")}
          </button>
        </form>

        <Link
          to="/login"
          className="block text-center text-xs text-muted-foreground hover:text-foreground mt-8"
        >
          {t("forgot.back_login")}
        </Link>
      </div>
    </div>
  );
}